export default "__VITE_ASSET__BTzbQURd__"